<!--
     <NumericInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value: Gives the field's serializable value

     Accepted props:
     - size
     - value
     - label
     - class
     - min
     - max
     - decimals (0: integer)
-->
<template>
  <v-text-field
    v-model="input"
    :size="props.size"
    :label="props.label"
    :class="[props.class || 'qmkey-form-input', {'required':props.required}]"
    :placeholder="props.placeholder"
    @click:append="increment"
    @click:prepend="decrement"
    outlined
    dense
    @change="enforce_min_max"
    background-color="#f2f2f2"
  >
    <template slot="append-outer">
      <v-icon 
        @click="increment"
        color="primary"            
      >
        {{ false || "mdi-plus" }}
      </v-icon>
    </template>
    <template slot="prepend">
      <v-icon         
        color="primary"
        @click="decrement"  
      >
        {{ false || "mdi-minus" }}
      </v-icon>
    </template>
  </v-text-field>
</template>


<script>
 export default {
   name: 'NumericInput',

   props: ['props'],

   data: (() => ({
     input: '',
   })),

   mounted() {
     // Load input with 
     this.input = this.parse_value(this.props.value) || 0;
   },

   computed: {
     value() {
       return this.parse_value(this.input);
     },
   },

   methods: {
     increment() {
       this.input = (this.parse_value(this.input)
                   + (Math.pow(10, -this.decimals || 0)));
     },

     decrement() {
       this.input = (this.parse_value(this.input)
                   - (Math.pow(10, -this.decimals || 0)));
     },

     enforce_min_max() {
       if (this.props.min
           && ((+ this.input) < this.props.min))
         this.input = this.props.min;
       else if (this.props.max
           && ((+ this.input) > this.props.max))
         this.input = this.props.max;
     },

     parse_value(val) {
       // Transforms val to numeric with props.decimals precision
       if (this.props.decimals)
         return +((+val).toFixed(this.props.decimals))
       return parseInt(val);
     }
   },

   watch: {
     props(p) {
       console.log('NumericInput.watch.props(', JSON.stringify(p), ')');
       this.input = p.value;
     }
   }
 }
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>